<template>

<SocialLink
  icon="medium-m"
  :size="size"
  :link="link"/>

</template>

<script>
import SocialLink from './SocialLink.vue'

export default {
  name: 'Medium',
  props: {
    size: String
  },
  computed: {
    link: function() {
      return "https://medium.com/@dsanchez_QR"
    }
  },
  components: {
    SocialLink
  }
}
</script>

<style lang="scss" scoped>
</style>
